const displayAllowedAgreement = (promoCode) => {
  return promoCode !== 'ARAG' && promoCode !== 'ACHMEA'
}

export default displayAllowedAgreement
